<template>
  <div>
    <provisioning-status @refresh="load" />
    <v-card class="main-card">
      <v-card-title class="screen-title">
        <span>Microsoft Peering向けNAPT一覧</span>
        <manual-button path="/ms-peering-napt-list/" />
      </v-card-title>
      <v-card-text class="pa-2" v-if="isLoaded">
        <v-row no-gutters>
          <v-col>
            <app-search
              :search="naptSetting.search"
              v-model="naptSetting.filter"
            />
          </v-col>
          <div class="d-flex flex-row ga-1 flex-wrap ml-2">
            <v-btn color="primary" @click="downloadCsv">一覧ダウンロード</v-btn>
          </div>
        </v-row>
        <div class="d-flex flex-row justify-end mb-2">
          <v-btn color="primary" @click="load">一覧更新</v-btn>
        </div>
        <app-table
          v-model:table-sort-by="naptSetting.sortBy"
          primary-key="vpnVnCode"
          :fields="naptSetting.fields"
          :items="naptSetting.items"
          :filter-option="naptSetting.filter_option"
          :filter="naptSetting.filter"
          :hover="true"
          sticky-header="50vh"
          @click:row="showNaptSettingReference"
        >
          <template #cell(vnName)="data">
            {{ $filter.emptyTo(data.item.vnName, "-") }}
          </template>
        </app-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import type { NatNaptDetailEntity } from "@/apis/MSPeeringIpApi";
import MSNaptSettingReference from "@/modals/msNaptSetting/MSNaptSettingReference.vue";
import { defineComponent } from "vue";
import type { SearchOption } from "@/components/AppSearch.vue";

export default defineComponent({
  name: "MSNaptSettingList",
  data() {
    return {
      naptSetting: {
        sortBy: {
          key: "vpnVnCode",
          order: "desc",
        } as SortItem,
        fields: [
          {
            key: "vpnVnCode",
            title: "VPN/VNコード",
            sortable: true,
            width: "300px",
          },
          {
            key: "vnName",
            title: "VNネットワーク名",
            sortable: true,
            width: "380px",
          },
          {
            key: "napt",
            title: "NAPT用グローバルIP数(現在/上限)",
            width: "300px",
            align: "end",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              value: string,
              key: null,
              item: NatNaptDetailEntity
            ) => {
              return `${item.usedNapt}/${item.upperLimitNapt}`;
            },
          },
        ] as AppTableHeader<NatNaptDetailEntity>[],
        items: [] as NatNaptDetailEntity[],
        search: {
          vpnVnCode: { type: "text", label: "VPN/VNコード" },
          vnName: { type: "text", label: "VNネットワーク名" },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          vpnVnCode: "like",
          vnName: "like",
        } as FilterOption,
      },
      keyId: "",
      isLoaded: false,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      /** クラウド向けNAPT用グローバルIP設定情報を取得API呼び出し処理 */
      const data = await this.$api.msPeeringIp.getAll();
      this.naptSetting.items = data.msPeeringList;
      this.keyId = data.msPeeringIpKeyId;
    },
    /** 詳細情報表示 */
    async showNaptSettingReference(item: NatNaptDetailEntity) {
      await this.$modal.show(MSNaptSettingReference, {
        keyId: this.keyId,
        naptSetting: item,
      });
      await this.load();
    },
    /** フロント側のみでのCSVダウンロード */
    downloadCsv() {
      // NAPT用グローバルIP数(現在/上限)ではなく、NAPTグローバルIP数(現在)・NAPTグローバルIP数(上限)に分けて表示なので、新たに列データを作る
      const csvFields = [...this.naptSetting.fields];
      csvFields.splice(
        2,
        1,
        { key: "usedNapt", title: "NAPTグローバルIP数(現在)" },
        { key: "upperLimitNapt", title: "NAPTグローバルIP数(上限)" }
      );

      this.$service.csvService.appTableCsvDownLoad(
        "saas_napt_setting",
        this.naptSetting.items.sortBy(["vpnVnCode", "desc"]),
        this.$service.csvService.genFieldList(csvFields)
      );
    },
  },
});
</script>
